import { gql, useQuery } from "@apollo/client";
import { SearchSelectInput } from "components/core";
import { FC } from "react";

interface MinistryPickerProps {
  id: string;
  label?: string;
  filter?: {
    status?: string;
  };
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  labelHidden?: boolean;
  values: any;
  errors?: any;
  touched?: any;
  setFieldValue: any;
  setFieldTouched?: any;
  setFieldError?: any;
  rawId?: boolean;
  position?: "top" | "bottom";
}

const GET_MINISTRY = gql`
  query GetMinistriesSelect($status: MinistryStatus) {
    ministries: getMinistries(
      sort: "name"
      page: 0
      pageSize: 0
      status: $status
    ) {
      _id
      code
      name
    }
  }
`;

export const MinistryPicker: FC<MinistryPickerProps> = ({
  id,
  label,
  rawId,
  filter,
  ...form
}) => {
  const { loading, data } = useQuery(GET_MINISTRY, {
    variables: {
      ...(filter ? filter : {}),
    },
    notifyOnNetworkStatusChange: false,
  });

  return (
    <SearchSelectInput
      id={id ?? "ministry"}
      label={label ?? "Ministry"}
      placeholder="Select Ministry"
      optionsLoading={loading}
      options={(data?.ministries ?? [])?.map((ministry: any) => ({
        label: {
          title: ministry.name as string,
        },
        value: rawId ? ministry?._id : ministry,
      }))}
      {...form}
      disabled={form.disabled}
    />
  );
};

export default MinistryPicker;
